import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 } // 5 seconds default
  };

  connect() {
    // Auto-dismiss after specified time
    this.dismissTimeout = setTimeout(() => {
      this.dismiss();
    }, this.dismissAfterValue);
  }

  disconnect() {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
    }
  }

  dismiss() {
    // Add dismissing class for slide-out animation
    this.element.classList.add('flash--dismissing');

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove();
    }, 300); // Match animation duration
  }

  // Allow manual dismiss by clicking the close button
  close(event) {
    event.preventDefault();
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
    }
    this.dismiss();
  }
}
